import { memo } from "react";

import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import { useTranslation } from "react-i18next";

type CalculatedMetricAdornmentProps = {
  isInterpolatedValue?: boolean;
};

const CalculatedMetricAdornment = ({ isInterpolatedValue }: CalculatedMetricAdornmentProps) => {
  const { t } = useTranslation("common");
  let titleAccess = t("calculated_value");
  if (isInterpolatedValue) {
    titleAccess += ` ${t("from")} ${t("interpolated_value")}`;
  }

  return <CalculateOutlinedIcon sx={{ ml: -1, mr: 0.5 }} color="disabled" titleAccess={titleAccess} />;
};

export default memo(CalculatedMetricAdornment);
